export const fixPjpegAvatar = (base64String: string): string => {
  if (!base64String) {
    return '';
  }

  return base64String.replace('data:image/pjpeg', 'data:image/jpeg');
};
